import _extends from "@swc/helpers/src/_extends.mjs";
// DS: I53
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
const Burger = (props)=>/*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        width: "0",
        height: "0",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("path", {
        d: "M6 4h12v3H6zM6 18h12v3H6zM2 11h20v3H2z"
    }))));
Burger.displayName = 'Burger';
export default Burger;
